'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.postCancelIfNeeded = exports.updateOrderIfNeeded = exports.fetchOrdersIfNeeded = exports.failureOrders = exports.receiveOrders = exports.requestOrders = exports.invalidateOrders = exports.filterOrders = exports.INVALIDATE_ORDERS = exports.FILTER_ORDERS = exports.FAILURE_ORDERS = exports.RECEIVE_ORDERS = exports.REQUEST_ORDERS = undefined;

var _css = require('antd/lib/message/style/css');

var _message = require('antd/lib/message');

var _message2 = _interopRequireDefault(_message);

var _css2 = require('antd/lib/notification/style/css');

var _notification = require('antd/lib/notification');

var _notification2 = _interopRequireDefault(_notification);

var _api = require('../api');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var REQUEST_ORDERS = exports.REQUEST_ORDERS = 'REQUEST_ORDERS'; /**
                                                                 * 订单相关Actions
                                                                 */
var RECEIVE_ORDERS = exports.RECEIVE_ORDERS = 'RECEIVE_ORDERS';
var FAILURE_ORDERS = exports.FAILURE_ORDERS = 'FAILURE_ORDERS';
var FILTER_ORDERS = exports.FILTER_ORDERS = 'FILTER_ORDERS';
var INVALIDATE_ORDERS = exports.INVALIDATE_ORDERS = 'INVALIDATE_ORDERS';

var filterOrders = exports.filterOrders = function filterOrders(filter) {
    return {
        type: FILTER_ORDERS,
        filter: filter
    };
};

var invalidateOrders = exports.invalidateOrders = function invalidateOrders(filter) {
    return {
        type: INVALIDATE_ORDERS,
        filter: filter
    };
};

var requestOrders = exports.requestOrders = function requestOrders(filter) {
    return {
        type: REQUEST_ORDERS,
        filter: filter
    };
};

var receiveOrders = exports.receiveOrders = function receiveOrders(filter, response) {
    var orders = response.data.map(function (x) {
        return {
            id: x.order_id,
            operations: x.logs,
            package: x.package || {},
            finances: x.finances || [],
            notes: [],
            ship: {},
            status: x.status,
            buyer: x.user,
            receiver: {
                name: x.receiver_name,
                mobile: x.receiver_mobile,
                address: {
                    province: x.receiver_state,
                    city: x.receiver_city,
                    district: x.receiver_district,
                    street: x.receiver_address
                }
            },
            created_at: x.created_at,
            shipping_fee: x.shipping_fee,
            total_fee: x.total_fee,
            discount_fee: x.discount_fee,
            product_fee: x.items_fee,
            items: x.items.map(function (y) {
                return {
                    order_item_id: y.order_item_id,
                    amount: y.qty,
                    price: y.price,
                    fee: (y.qty * y.price).toFixed(2),
                    weight: y.weight,
                    title: y.product_title,
                    subTitle: y.product_sub_title,
                    preview: y.product_preview,
                    specs: y.specification,
                    work: {
                        id: y.work_id
                    }
                };
            })
        };
    });
    return {
        type: RECEIVE_ORDERS,
        filter: filter,
        orders: orders,
        pagination: response.meta.pagination
    };
};
var failureOrders = exports.failureOrders = function failureOrders(error) {
    return {
        type: FAILURE_ORDERS,
        error: error
    };
};

var shouldFetchOrders = function shouldFetchOrders(state, filter) {
    var orders = state.order.orders;
    if (orders.items.length === 0) {
        return true;
    }
    if (orders.isFetching) {
        return false;
    }
    // return orders.didInvalidate
    return true;
};

var fetchOrdersIfNeeded = exports.fetchOrdersIfNeeded = function fetchOrdersIfNeeded(filter, page) {
    return function (dispatch, getState) {
        if (shouldFetchOrders(getState(), filter)) {
            return dispatch(function (dispatch) {
                dispatch(requestOrders(filter, page));
                return (0, _api.fetchOrders)(filter, page).then(function (response) {
                    dispatch(receiveOrders(filter, response.data));
                }).catch(function (error) {
                    _notification2.default['error']({
                        message: '获取失败',
                        description: error.response && error.response.data && error.response.data.message
                    });
                    dispatch(failureOrders(error));
                });
            });
        }
    };
};

var updateOrderIfNeeded = exports.updateOrderIfNeeded = function updateOrderIfNeeded(id, filter) {
    return function (dispatch) {
        return (0, _api.updateOrder)(id).then(function (response) {
            dispatch(fetchOrdersIfNeeded(filter, 1));
        }).catch(function (error) {
            _notification2.default['error']({
                message: '修改失败',
                description: error.message + error.response && error.response.data && error.response.data.message
            });
            dispatch(failureOrders(error));
        });
    };
};

var postCancelIfNeeded = exports.postCancelIfNeeded = function postCancelIfNeeded(id, value, router) {
    return function (dispatch) {
        return (0, _api.cancelOrder)(id, value).then(function (response) {
            _message2.default.success('关闭成功');
            dispatch(fetchOrdersIfNeeded({}, 1));
        }).catch(function (error) {
            _notification2.default['error']({
                message: '订单关闭失败',
                description: error.message + error.response && error.response.data && error.response.data.message
            });
            dispatch(failureOrders(error));
        });
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/js/actions/order.js
// module id = 603
// module chunks = 0